import React from "react";
import { MdCheckCircle, MdCancel } from "react-icons/md";

export function OverviewYesNo({ value }) {
  return value ? (
    <>
      <MdCheckCircle style={{ color: "green", marginRight: "0.5em" }} />
      Yes
    </>
  ) : (
    <>
      <MdCancel style={{ color: "red", marginRight: "0.5em" }} />
      No
    </>
  );
}

/**
 * Standard overview label + value row with optional edit control on the right.
 */
export function OverviewFieldRow({ icon: Icon, label, value, editControl, marginTop = 16, first = false }) {
  return (
    <>
      <div className="info_descr" style={first ? undefined : { marginTop }}>
        {Icon ? <Icon style={{ color: "#93ab3c", marginRight: "0.5em" }} /> : null}
        {label}
      </div>
      <div className="info_span" style={{ position: editControl ? "relative" : undefined }}>
        {value ?? "Not set"}
        {editControl ? (
          <span
            style={{
              position: "absolute",
              right: "0px",
              top: "50%",
              transform: "translateY(-50%)",
            }}
          >
            {editControl}
          </span>
        ) : null}
      </div>
    </>
  );
}

export function formatProjectStatus(status) {
  if (!status) return "—";
  if (status === "Inprogress") return "In Progress";
  return status;
}

export function projectStatusColor(status) {
  switch (status) {
    case "Created":
      return "#c0392b";
    case "Assigned":
    case "Inprogress":
      return "#e67e22";
    case "Completed":
      return "#27ae60";
    case "Settled":
      return "#17a2b8";
    case "Abandoned":
      return "#7f8c8d";
    default:
      return "#333333";
  }
}

export function getPrimaryClientFromProject(project) {
  const list = Array.isArray(project?.associated_clients) ? project.associated_clients : [];
  if (!list.length) return null;
  const sorted = [...list].sort((a, b) => (a.orderindex ?? 0) - (b.orderindex ?? 0));
  return sorted[0]?.client || null;
}
